import { SxProps, Theme } from '@mui/material';

const style: SxProps<Theme> = [
  {
    minHeight: 'calc(100vh - (114px + 57px))', // Height moins Header + Footer
  },
];

export default style;
